import axios from 'axios';
import api from './api';

const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').trim().replace(/\/$/, '');

export const cardsAPI = {
  me: () => api.get('/api/cards/me'),
  save: (data) => api.put('/api/cards/me', data),
  photo: () => api.get('/api/cards/me/photo', { responseType: 'blob' }),
  uploadPhoto: (file) => { const fd = new FormData(); fd.append('file', file); return api.post('/api/cards/me/photo', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  removePhoto: () => api.delete('/api/cards/me/photo'),
  makeQr: () => api.post('/api/cards/me/qr'),
  downloadQr: (format) => api.get('/api/cards/me/qr', { params: { format }, responseType: 'blob' }),
};

const pub = axios.create({ baseURL: API_BASE_URL });
export const cardPublicAPI = {
  get: (slug) => pub.get(`/api/card-public/${slug}`),
  photoUrl: (slug) => `${API_BASE_URL}/api/card-public/${slug}/photo`,
  vcardUrl: (slug) => `${API_BASE_URL}/api/card-public/${slug}/vcard`,
};
